export const EventConstant = {
  add_bookmark_event_name: "add_bookmark_event_click",
  delete_bookmark_event_name: "delete_bookmark_event_click",
  posted_bookmark_event_name: "posted_bookmark_event_click",
  deleted_bookmark_event_name: "deleted_bookmark_event_click",
};
